import React, {Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import {UserAction} from "../actions/UserAction"
import {SearchAction} from "../actions/SearchAction"
import {Container} from "reactstrap"
import {izEmpty, izNotEmpty} from "../constants";
import i18n from "i18next";
import LinkPreview from "./LinkPreview";

class AdverseMediaCard extends Component {

    render() {

        const searchResultData = this.props.search
        const {searchResults, includeAdverseMedia, additionalMediaLinks} = searchResultData

        if (izNotEmpty(searchResults)) return "";
        if (!includeAdverseMedia) return "";

        const isAdverseMediasEmpty = izEmpty(additionalMediaLinks);

        return (
            <>
                <section className="mb-50 pb-20">
                    <Container>
                        <div className="adverse-media-result-container custom-card-border justify-content-center">
                            {isAdverseMediasEmpty
                                ?
                                <span className="adverse-media-not-found">
                                    {i18n.t('adverseMediasNotFount')}
                                </span>
                                :
                                <div className="adverse-media-found">
                                    <div className="adverse-media-found-title">
                                        <strong>{i18n.t('adverseMedias')} </strong>
                                        <label className="adverse-media-warn">{i18n.t('adverseMedias_warn')} </label>
                                    </div>

                                    <div className="row justify-content-center mb-20">
                                        <div className="col-12">
                                            {additionalMediaLinks.map((adverseMedia, index) => {
                                                let {link, title, siteName, image} = adverseMedia;

                                                return <LinkPreview order={index}
                                                                    key={index}
                                                                    link={link}
                                                                    title={title}
                                                                    siteName={siteName}
                                                                    image={image}/>;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </Container>
                </section>
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        common: state.common,
        user: state.user,
        search: state.search
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        searchAction: SearchAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdverseMediaCard);